import { Controller } from "@hotwired/stimulus"

// Guards a destructive delete behind a typed confirmation. The Delete button
// opens a native <dialog>; the submit button stays disabled until the input
// exactly matches "Delete". Esc closes the dialog natively.
export default class extends Controller {
  static targets = ["dialog", "input", "submit"]

  open() {
    this.inputTarget.value = ""
    this.submitTarget.disabled = true
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  check() {
    this.submitTarget.disabled = this.inputTarget.value !== "Delete"
  }
}
